export default __webpack_public_path__ + "static/media/columns.9dc2c144.svg";